import clusterSmallIcon from '~/assets/images/icon_map-cluster-small.png';
import clusterLargeIcon from '~/assets/images/icon_map-cluster-large.png';

const clusterStyles = [
  {
    width: 54,
    height: 53,
    url: clusterSmallIcon,
    textColor: 'white',
    textSize: 12,
  },
  {
    width: 54,
    height: 53,
    url: clusterLargeIcon,
    textColor: 'white',
    textSize: 14,
  },
  {
    width: 54,
    height: 53,
    url: clusterLargeIcon,
    textColor: 'white',
    textSize: 16,
  },
];

export default clusterStyles;
